<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <h5 class="mb-4">Solicitudes de nuevos conductores</h5>
      </div>
    </div>
    <DriverModal
      :show="modalVisible"
      :driver="selectedDriver"
      mode="solicitudes"
      @close="modalVisible = false"
      @updated="loadDrivers"
    />
    <div v-if="error" class="alert alert-danger">{{ error }}</div>
    <div v-if="loading" class="text-center py-5">
      <div class="loader-box">
        <div class="loader-3"></div>
      </div>
    </div>
    <div v-else class="row user-card general-widget">
      <div
        v-for="driver in drivers"
        :key="driver.id"
        class="col-md-6 col-lg-6 col-xl-4 box-col-4"
      >
        <div class="card custom-card">
          <div class="card-header">
            <img
              class="img-fluid"
              :src="driver.vehiclePhoto || placeholderImage"
              alt="Vehículo"
            />
          </div>
          <div class="card-profile">
            <img
              class="rounded-circle"
              :src="driver.driverPhoto || placeholderAvatar"
              alt="Conductor"
            />
          </div>
          <div class="text-center profile-details">
            <h4>{{ driver.name || '—' }}</h4>
            <h6>{{ driver.email || '—' }}</h6>
            <p v-if="driver.phone" class="mb-1 text-muted small">{{ driver.phone }}</p>
            <p v-if="driver.vehiclePlate" class="mb-0 text-muted small">{{ driver.vehiclePlate }}</p>
          </div>
          <ul class="card-social">
            <li>
              <a href="javascript:void(0)" @click.prevent="verSolicitud(driver)">
                <i class="fa fa-eye"></i>
              </a>
            </li>
          </ul>
          <div class="card-footer row">
            <div class="col-4 col-sm-4">
              <h6>Permiso</h6>
              <h3 class="small">{{ formatTimestamp(driver.permitExpirationDate) || '—' }}</h3>
            </div>
            <div class="col-4 col-sm-4">
              <h6>Antecedentes</h6>
              <h3 class="small">{{ formatTimestamp(driver.criminalRecordExpirationDate) || '—' }}</h3>
            </div>
            <div class="col-4 col-sm-4">
              <h6>Credencial</h6>
              <h3 class="small">{{ formatTimestamp(driver.credentialExpirationDate) || '—' }}</h3>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading && drivers.length === 0" class="col-12 text-center text-muted py-5">
        No hay solicitudes pendientes
      </div>
    </div>
  </div>
</template>

<script>
import { fetchConductores } from '@/services/conductoresApi';
import DriverModal from '@/components/drivers/DriverModal.vue';

export default {
  name: 'SolicitudesPage',
  components: { DriverModal },
  data() {
    return {
      drivers: [],
      loading: false,
      error: '',
      modalVisible: false,
      selectedDriver: null,
      placeholderImage: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="120" viewBox="0 0 200 120"%3E%3Crect fill="%23eee" width="200" height="120"/%3E%3Ctext fill="%23999" x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle"%3ESin imagen%3C/text%3E%3C/svg%3E',
      placeholderAvatar: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80"%3E%3Ccircle fill="%23ddd" cx="40" cy="40" r="40"/%3E%3Ctext fill="%23999" x="50%25" y="55%25" dominant-baseline="middle" text-anchor="middle" font-size="24"%3E?%3C/text%3E%3C/svg%3E',
    };
  },
  mounted() {
    this.loadDrivers();
  },
  methods: {
    async loadDrivers() {
      this.loading = true;
      this.error = '';
      try {
        this.drivers = await fetchConductores('solicitudes');
      } catch (err) {
        this.error = err.message || 'Error al cargar solicitudes';
        this.drivers = [];
      } finally {
        this.loading = false;
      }
    },
    formatTimestamp(ts) {
      if (!ts) return '—';
      const date = new Date(ts);
      if (Number.isNaN(date.getTime())) return '—';
      return date.toLocaleDateString('es-CL', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },
    verSolicitud(driver) {
      this.selectedDriver = driver;
      this.modalVisible = true;
    },
  },
};
</script>

<style scoped>
.user-card.general-widget .custom-card {
  padding: 0;
}
.user-card.general-widget .custom-card .card-header {
  padding: 0;
}
.user-card.general-widget .custom-card .card-header img {
  width: 100%;
  height: 160px;
  object-fit: cover;
  margin-top: 0;
  display: block;
}
.user-card.general-widget .custom-card .card-profile {
  margin-top: -45px;
  text-align: center;
}
.user-card.general-widget .custom-card .card-profile img {
  height: 110px;
  width: 110px;
  object-fit: cover;
  object-position: center top;
  padding: 7px;
  background-color: var(--body-color, #fff);
  border-radius: 50%;
  z-index: 1;
  position: relative;
}
.user-card .custom-card .card-footer h3.small {
  font-size: 12px;
  font-weight: 500;
}
</style>
